import { Component, OnInit , AfterViewInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {DataService} from "../data.service";
import {environment} from "../../environments/environment.prod";
import {Router} from '@angular/router' ;
import {Meta,Title,SafeUrl,DomSanitizer} from '@angular/platform-browser';
import {HomeComponent} from '../home/home.component';

declare var $:any;

@Component({
  selector: 'app-modules-by-theme',
  templateUrl: './modules-by-theme.component.html',
  styleUrls: ['./modules-by-theme.component.css']
})
export class ModulesByThemeComponent implements OnInit,AfterViewInit {
  id:number=-1;
  companyId:number=-1;
  moduleData:any[]=[];
  userId:number=-1;
  arr=Array;
  imgPath:string="";
  moduleId:number=0;
  isShareMenu:boolean=false;
  shareUrl:string="";
  isLink:boolean=true;
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  themeName:string="";
  myurl:string="whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
  // myurl:string="whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";
  freeTag:boolean=false;
  isLoading:boolean=false;

  constructor(private route:ActivatedRoute,private service:DataService,private router:Router,private meta:Meta,private sanitizer:DomSanitizer,private home:HomeComponent) {


   }

  ngOnInit() {
    this.route.params.subscribe(params=>{
      this.id=params['id'];
      this.themeName=params['name'];
    });
    this.companyId=sessionStorage.getItem("companyId")!=null ? parseInt(sessionStorage.getItem("companyId")) : -1;
    this.userId=localStorage.getItem("UserId")!=null ? parseInt(localStorage.getItem("UserId")):-1;
      this.imgPath=environment.imagePath;
    this.themeModuleByUser();

    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));

  }

  ngAfterViewInit(){
    $(window).scrollTop(0);
      $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
  }

  themeModuleByUser(){
    this.isLoading=true;
    const inputJson={
      "ThemeId":this.id,
      "UserId":this.userId
    }
   // console.log(inputJson);
    this.service.ThemeModuleByUser(inputJson).
    subscribe(
      (result:any[])=>{
        if(result['Status']=="Success"){
          this.isLoading=false;
          this.moduleData=result['DashBoardData'];
        } else {
          this.isLoading=false;
          this.service.alert(result['Message'],"error");
        }
      },
      (error)=>{
        this.isLoading=false;
       console.log(error);
      }
    )

  }

  getNumber(rating){
    return Math.round(rating);
  }

  hideShareOptions(pvarId){
    if(this.moduleId==pvarId)
    this.isShareMenu=false;
  }

  addBookmark(pvarId,status) {
    if(this.userId==-1){
      this.service.alert("Please login to use this feature","error");
      return false;

    } else {
      const inputJson = {
          "ModuleId":pvarId,
          "Status":status,
          "UserId":this.userId
      }

      if(status=="False"){
        inputJson.Status=true
      }
      else if(status=="True"){
        inputJson.Status=false
      }
       // console.log(inputJson);
        this.service.AddBookmark(inputJson)
        .subscribe(
          (result:any[])=>{
            if(result['Status']=="Success"){
              if(inputJson.Status==true)
              this.service.alert("Bookmark added successfully","success");
              else
              this.service.alert("Bookmark removed successfully","success");

            } else {
              this.service.alert(result['Message'],"error");
            }

          },
          (error)=>{
           // console.log(error);
          },
          ()=>{

            this.moduleData=[];
            setTimeout(()=>{

              this.ngOnInit();
            },1000)


          }
        )
    }

  }

  showShareOptions(pvarId){
   // console.log(pvarId);
    if(this.moduleId==pvarId){
        this.isShareMenu=!this.isShareMenu;
    }
    else {
        this.isShareMenu=true;
    }
    this.moduleId=pvarId;


    this.updateMeta();
  }


  goToModule(pvarId,pvarName,isLink,pvarIsFree){
   // console.log("link" , isLink);

    if(isLink==true){

      if(this.userId!=-1){
      if(localStorage.getItem("planId")=='-1' && pvarIsFree==false){
        const inputJson={
          "ModuleId":pvarId,
          "UserId":this.userId
        }
       // console.log(inputJson);
        this.service.ClickOnPaidModule(inputJson)
        .subscribe(
          (result:any[])=>{
           // console.log(result);
            if(result['Status']=="Success"){

            }
            else{
              this.service.alert(result['Message'],"error");
            }
          },
          (error:Error)=>{
           // console.log(error);
          }
        )

      }

    }

      var name=pvarName.split(' ').join('-');

      this.router.navigate(['module',name,pvarId]);

    } else {
      return false;
    }
  }

  // Harkamal Singh : Method to update meta tag
  updateMeta(){
    this.meta.updateTag({
content: 'http://happcoach.com/PilotServices/Module/'+this.moduleId+'.html'
},
"property='og:url'"
);
  // this.shareUrl="https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
  this.shareUrl="http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";

  }
// Harkamal Singh : Method to share to facebook,twitter,linkedin,g+
  shareToSocial(pvarChoice:number){
    if(pvarChoice==0){ // facebook
        window.open(
          "http://www.facebook.com/sharer/sharer.php?u="+this.shareUrl,
          '_blank' // <- This is what makes it open in a new window.
        );
    }

    if(pvarChoice==1){//twitter
      window.open(
      "https://twitter.com/intent/tweet?url="+this.shareUrl,
      '_blank'
    );
  }
    if(pvarChoice==2){//linkedin
      window.open(
      "https://www.linkedin.com/shareArticle?mini=true&url="+this.shareUrl,
      '_blank'
    )
    }

    if(pvarChoice==3){//google plus
      window.open(
      "https://plus.google.com/share?url="+this.shareUrl,
      '_blank'
    )
    }

  }

  sanitize(){
    let url:string="whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
    // let url:string="whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";

    this.myurl=url;
     let s:SafeUrl=this.sanitizer.bypassSecurityTrustUrl(this.myurl);
     return s;
  }
shareWhatsApp(){
     window.location.href = "whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
     // window.location.href = "whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";

   }

   showActiveModule(pvarChoice){
     this.home.showActiveModule(pvarChoice);
   }

   themeModule(pvarId){
     this.router.navigate(['/']).then(()=>{
      this.router.navigate(['module-by-theme',pvarId]);
     })
   }

   freeActive(){
     this.freeTag=true;
     this.isLink=false;
   }

   freeInactive(){
     this.freeTag=false;
     this.isLink=true;
   }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/modules-by-theme/modules-by-theme.component.ts